/**
 * Class to define constants of the application
 * @class Constants
 */

export default () => ({
  AGENT_BUSINESSES: `/admin/agent/businesses.json`,
  AGENCY_PATH: `/admin/agent/agencies/`,
  ADD_NEW_AGENCY_PATH: `/admin/agent/agencies.json`,
  ADD_NEW_AGENT_PATH: `/admin/agent/agents.json`,
  UPDATE_AGENT_PATH: `/admin/agent/agents/`,
  QUALIFY_PROSPECT_AS_OPPORTUNITY_PATH: `/admin/agent/businesses/leads/`,
  CLOSE_OPPORTUNITY_PATH: `/admin/agent/businesses/opportunities/`,
  CLOSE_PRODUCTS_PATH: `/admin/agent/businesses/opportunities/`,
  CLOSE_ALL_PRODUCTS_PATH: `/admin/agent/businesses/opportunities/`,
  CLOSE_PROSPECT_PATH: `/admin/agent/businesses/leads/`,
  RESET_PASSWORD_EMAIL: `/admin/agent/agents/send_reset_password_email`,
  PREFILL_QUOTES: `/api/v1/prefill/quotes`,
  EMAILS_PATH: `/admin/agent/emails.json`,
  AGENCY_CARRIERS_PATH: `/api/v1/agency_carriers`,
  GENERATE_ACORDS: `/admin/agent/acords.json`,
  ONBOARDING_PATH: `/onboarding.json`,
});

export const FORBIDDEN_PAGE_URL = '/forbidden';
export const UNAUTHORIZED_PAGE_URL = '/401';
export const DEPRECATED_FEATURE_PAGE = '/410';
export const QUICK_LINKS_PAGE_URL = '/quick-links';
export const ONBOARDING_PAGE_URL = '/onboarding';
export const INTERNAL_LOGIN_PAGE_URL = '/internal-login';
export const LOGIN_PAGE_URL = '/login';
export const PUBLIC_ROUTES = [
  UNAUTHORIZED_PAGE_URL,
  FORBIDDEN_PAGE_URL,
  DEPRECATED_FEATURE_PAGE,
  INTERNAL_LOGIN_PAGE_URL,
  LOGIN_PAGE_URL,
];
